const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOG_OUT = 'LOG_OUT';
const SET_DEVICE_TOKEN = 'SET_DEVICE_TOKEN';

// eslint-disable-next-line camelcase
const loginSuccess = ({ access_token, roles }) => ({
  type: LOGIN_SUCCESS,
  token: access_token,
  roles,
});

const logOut = () => ({
  type: LOG_OUT,
});

const setDeviceToken = (deviceToken) => ({
  type: SET_DEVICE_TOKEN,
  deviceToken,
});

export default {
  LOGIN_SUCCESS,
  loginSuccess,
  LOG_OUT,
  logOut,
  SET_DEVICE_TOKEN,
  setDeviceToken,
};
